module.exports = __webpack_public_path__ + "img/service_design_8_mob_2x.b4dda9b8.jpg";